import AppContext from 'App/AppContext';
import { IPFontIcon, IPTooltipHost } from 'baseComponents';
import { linkIcon, validIcon } from 'globalStyles';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getExternalUrl } from 'utils/url';

interface ICopyLinkProps {
  url: string;
}

const CopyLink = (props: ICopyLinkProps) => {
  const { t } = useTranslation('translation');
  const appContext = useContext(AppContext);
  const [copied, setCopied] = useState<boolean>(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyUrl = () => {
    const externalUrl = getExternalUrl(props.url, appContext.user.tenant, appContext.user.login.tenantId);
    navigator.clipboard.writeText(externalUrl);
    setCopied(true);
    setTimer(setTimeout(() => setCopied(false), 2000));
  };

  return (
    <IPTooltipHost
      content={t('translation:CopyLink.Tooltip')}
      styles={{
        root: {
          selectors: {
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      }}
    >
      {!copied && <IPFontIcon {...linkIcon} onClick={copyUrl}></IPFontIcon>}
      {copied && <IPFontIcon {...validIcon}></IPFontIcon>}
    </IPTooltipHost>
  );
};

export default CopyLink;
